import styled from 'styled-components';
import * as fonts from 'view/styles/fonts';

// eslint-disable-next-line rulesdir/no-styled-export
export const RequestTypeList = styled.span`
    ${fonts.small};
`;
